import 'trackjs';

import { legacyHypernovaSetConfigOnce } from '#/config/legacyHypernovaConfigUtils';
import type { AppConfig } from '#/config/types/AppConfig';
import { getEmbedSearchWidgetIdFromPathname } from '#/modules/embedSearchWidget/utils/getEmbedSearchWidgetIdFromPathname';
import { getAnalyticsApplicationContextProps } from '#/utils/analytics/helpers/getAnalyticsApplicationContextProps';
import { registerMixpanelProperties } from '#/utils/analytics/helpers/mixpanel';
import { initXMLHttpRequestActiveCounter } from '#/utils/http/initXMLHttpRequestActiveCounter';
import { trackError } from '#/utils/trackError';
import { initializeAppVersionStore } from '#/zustand-stores/appVersionStore';

export function renderingBootstrapClient(config: AppConfig) {
  const embedSearchWidgetId = getEmbedSearchWidgetIdFromPathname(
    window.location.pathname,
  );

  legacyHypernovaSetConfigOnce(config);
  initializeAppVersionStore(config.idealist.versionNumber);

  registerMixpanelProperties(getAnalyticsApplicationContextProps());

  if (embedSearchWidgetId)
    registerMixpanelProperties({ embed_search_widget_id: embedSearchWidgetId });

  if (window.Idealist.debugXhr) {
    initXMLHttpRequestActiveCounter();
  }

  const { errorsBeforeTrackJsInstalled, trackErrorBeforeTrackJs } =
    window.Idealist;

  if (errorsBeforeTrackJsInstalled && trackErrorBeforeTrackJs) {
    errorsBeforeTrackJsInstalled.forEach((error) => trackError(error));
    window.removeEventListener('error', trackErrorBeforeTrackJs);
  }
}
